import { LeaderboardPlayerData } from "../../../../models/leaderboard";


export const groupPlayersByMatch = (data: LeaderboardPlayerData[]) => {
  const matchGroups: { [key: string]: LeaderboardPlayerData[] } = {};
  
  data.forEach(player => {
    const matchId = player.matchId;
    if (!matchGroups[matchId]) {
      matchGroups[matchId] = [];
    }
    matchGroups[matchId].push(player);
  });
  
  return matchGroups;
};


export interface LeaderboardPlayerDataStrings {
  id: string;
  playerId: string;  // Add this
  firstName: string;
  lastName: string;
  profilePicture?: string;
  matchId: string;   // Add this
  totalStableford: number;
  matchScores?: Record<string, string>;  // Keeps string type for UI display
  playerForTeamId?: string;  // Add this if needed
  playerForTeamName?: string;  // Add this if needed
  playerForTeamLogo?: string;  // Add this if needed
  rankingScore: number;  // Changed to number
  totalPoints?: number;
}

export const combinePlayerScores = (data: LeaderboardPlayerData[]): LeaderboardPlayerDataStrings[] => {
  const matchGroups = groupPlayersByMatch(data);
  const playerMap = new Map<string, LeaderboardPlayerDataStrings>();
  
  Object.entries(matchGroups).forEach(([matchId, players]) => {
    players
      .sort((a, b) => (b.rankingScore ?? 0) - (a.rankingScore ?? 0))
      .forEach(player => {
        
        if (playerMap.has(player.playerId)) {
          const existing = playerMap.get(player.playerId)!;
          const currentScore = player.rankingScore !== undefined && player.rankingScore !== null
            ? `${Number(player.rankingScore.toFixed(2))}` 
            : ' - ';
            
          existing.matchScores = {
            ...existing.matchScores,
            [matchId]: currentScore
          };
          
          // Calculate total score as number
          const totalScore = Object.values(existing.matchScores || {})
            .reduce((sum, score) => {
              const numScore = score === ' - ' ? 0 : Number(score);
              return sum + numScore;
            }, 0);
            
          existing.rankingScore = Number(totalScore.toFixed(2));
        } else {
          const initialMatchScore = player.rankingScore !== undefined && player.rankingScore !== null
            ? `${Number(player.rankingScore.toFixed(2))}` 
            : ' - ';
            
          playerMap.set(player.playerId, {
            ...player,
            id: player.playerId,
            matchScores: { [matchId]: initialMatchScore },
            rankingScore: player.rankingScore ?? 0
          });
        }
      });
  });

  // Simple numeric sort since rankingScore is now always a number
  return Array.from(playerMap.values())
    .sort((a, b) => b.rankingScore - a.rankingScore);
};
